import React from 'react';
import { ContentContainer, PageContainer } from './SplashPage.styles';
import { ContentSafeAreaView, LogoLoader } from '../../../components';

const SplashPage = () => {
  return (
    <PageContainer>
      <ContentSafeAreaView removeBottom hideLogo>
        <ContentContainer>
          <LogoLoader />
        </ContentContainer>
      </ContentSafeAreaView>
    </PageContainer>
  );
};

export default SplashPage;
